import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { BulkUpdateComponent } from '../bulk-update/bulk-update.component';
import { CloneDialogComponent } from '../clone-dialog/clone-dialog.component';
import { ConformationComponent } from '../conformation/conformation.component';
import { EditPollComponent } from '../edit-poll/edit-poll.component';
import { ExecuteComponent } from '../execute/execute.component';
import { NewPollComponent } from '../new-poll/new-poll.component';
import { ShowPollResultComponent } from '../show-poll-result/show-poll-result.component';

@Component({
  selector: 'app-polls',
  templateUrl: './polls.component.html',
  styleUrls: ['./polls.component.scss'],
  encapsulation :ViewEncapsulation.None
})
export class PollsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] ;
  dataSource :any;
  searchText;
  filteredpollList = [];
  pollList = [];
  allGroups = [];
  bmList = [];
  showSpinner = false;
  screenwidth =null;
  dialogwidth = null;
  userInfo = JSON.parse(localStorage.getItem('User'));
  userRole = this.userInfo.roles[0];
  selectedPolls =[];

  constructor(private dialog: MatDialog,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private router:Router) {
    
  }

  ngOnInit(): void {
    this.screenwidth = screen.width;
    if(this.screenwidth < 500){
      this.dialogwidth = '90%';
    }else{
      this.dialogwidth = '50%';
    }

    if(this.userRole =='admin'){
      // this.displayedColumns = [ 'name', 'poll_type','message','expiry_time', 'updated_at', 'id', 'created_at','adhoc'];
      this.displayedColumns = ['selected', 'name', 'poll_type','message','expiry_time', 'updated_at', 'id', 'created_at','adhoc','group_id'];
    }else if(this.userRole =='manager'){
      this.displayedColumns = ['name', 'poll_type','message','expiry_time', 'updated_at', 'created_at'];
    }
    
    console.log(this.screenwidth);
    this._apiService.getGroupList().subscribe(res => {
      if (res) {
        this.allGroups = res;
        console.log(res);
        // this.dialogRef.close();
      }
    },
    (error)=>{
      console.log(error);
    });

    this._apiService.getbmList().subscribe(res => {
      if (res) {
        this.bmList = res;
        console.log(this.bmList);
      }
    },
    (error)=>{
      console.log(error);
    });
    this.refreshPollList();
    this.dataSource.sort = this.sort;
  }

  refreshPollList(){
    this.showSpinner = true;
    this._apiService.getPollList().subscribe(res => {
      if (res) {
        console.log(res);
        this.pollList = res;
        this.filteredpollList = res;
        let pollListWithSelectedValue = [];
        for(var i=0; i<this.pollList.length; i++){
          let instance = this.pollList[i];
          instance['selected'] = false;
          pollListWithSelectedValue.push(instance);
        }
        this.dataSource = new MatTableDataSource<pollLists>(pollListWithSelectedValue);
        setTimeout(() => this.dataSource.paginator = this.paginator);
        setTimeout(() => this.dataSource.sort = this.sort);
        this.showSpinner = false;
      } 
    },
    (error)=>{
      console.log(error);
    });
  }

  openViewDialog(): void {
    const dialogRef = this.dialog.open(ShowPollResultComponent, {
      width: this.dialogwidth ,
      height : '100%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  navigateToExecute(id){
    this._apiService.getPollOptionList(id).subscribe(res => {
      if (res) {
        console.log(res);
        if(res.length >0){
          this.router.navigate(['home/execute-poll/',id]);
        }else{
          this._snackBar.open('Add Poll Option To Execute.', 'OK', { duration: 3000 });
        }
        
      }
    },
    (error)=>{
      console.log(error);
    });
    
    // this.router.navigate(['/debugLogs/debugLogContainer/logs/',userId]);
    // const dialogRef = this.dialog.open(ExecuteComponent, {
    //   width: this.dialogwidth,
    //   data: {name: this.name, animal: this.animal}
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('The dialog was closed');
    //   this.animal = result;
    // });
  }

  openEditPoll(pollinfo){
    const dialogRef = this.dialog.open(EditPollComponent, {
      width: this.dialogwidth,
      data: {poll:pollinfo, bmList:this.bmList, allGroups:this.allGroups}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.refreshPollList();
    });
  }

  deletePoll(id){

    const dialogRef = this.dialog.open(ConformationComponent, {
      width: '20rem',
      data: {id: id,type:'Poll'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.refreshPollList();
    });

    
  }

  clonePoll(id){
    console.log(id);
    const dialogRef = this.dialog.open(CloneDialogComponent, {
      width: '20rem',
      data: {id: id, type:"poll"}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.refreshPollList();
    });
  }

  onSearch(e){
    if(e == null){
      this.dataSource = new MatTableDataSource<pollLists>(this.pollList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    this.filteredpollList = this.pollList.filter(ele => ele.name.toLowerCase().includes(e.toLowerCase()));
    this.dataSource = new MatTableDataSource<pollLists>(this.filteredpollList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  openChangeGroupsforPollDialog(){
    let selectedPollIds = [];
    for(var i=0; i<this.pollList.length; i++){
      if(this.pollList[i].selected){
        this.selectedPolls.push(this.pollList[i]);
        selectedPollIds.push(this.pollList[i].id);
      }
    }
    const dialogRef = this.dialog.open(BulkUpdateComponent, {
      width: '20rem',
      data: {selectedPolls:this.selectedPolls,selectedPollIds:selectedPollIds}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.refreshPollList();
    });
  }

  onChangeSelect(data){
    console.log(data)
    // if(data.selected){
    //   this.selectedPolls.push(data);
    // }else{

    // }
  }

}


export interface pollLists {
  id: number;
  name: string;
  description: string;
  message:string;
  company_id: number;
  created_at:string;
  updated_at:string;
  poll_type:string;
  allow_vote_change:boolean;
  adhoc:boolean;
  group_id:number;
  members:[];
  correction_option:number;
  created_by:number;
  expiry_time:number;
  selected: boolean;
};